import script from "./ArgonSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonSelect.vue?vue&type=script&setup=true&lang=js"

import "./ArgonSelect.vue?vue&type=style&index=0&id=22e40d13&scoped=true&lang=css"
import "./ArgonSelect.vue?vue&type=style&index=1&id=22e40d13&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22e40d13"]])

export default __exports__